/**
 * @ Author: Kamila Michalak (k.michalak@kstudio.pl)
 * @ Create Time: 2019-07
 * @ Modified by: Kamil Michalak (k.michalak@kstudio.pl)
 * @ Modified time: 2019-11
 */

//import { AppBar, Button, IconButton, Toolbar } from "@mui/material"
import { AppBar, Toolbar } from "@mui/material"
//import SearchIcon from "@mui/icons-material/Search"
import { ProfileMenu } from "components/ProfileMenu"
// import { ChannelListMenu } from "components/ChannelListMenu"
import { CreateComponent } from "components/utils/CreateComponent"
//import logo from "img/Quickline_logo.svg"
import logoWhite from "img/Quickline_logo_white.svg"
//import React from "react"
import { useState, useRef, useEffect, useLayoutEffect, memo } from "react"
import { useNavigate } from "react-router"
//import { Link } from "react-router"
import { TopMenu } from "./TopMenu"
import { useNavigateRouteAdd } from "components/utils/RouteUtils"
import { ROUTE_NAMES } from "site-ql/RouteConst"
import { RouteTab, RouteTabs } from "./utils/RouteTab"
import searchIcon from "components/welcomeModal/icons/search_gap.svg"
import CloseIcon from '@mui/icons-material/Close'
import { rootStore } from "store/RootStore"
import { startVConsole } from "scenes/Internals/Internals"
import { useMediaQuery } from "hooks/useMediaQyery"
//import { isMobileScreenSize } from "utils/Utils"


const styles = theme => ({
	//  MTV-2171 ToolBar: { display: "flex", /*width: theme.themeDefaultWidth,*/ margin: "0 auto", backgroundColor: "#2A2A2A" },
	ToolBar: { display: "flex", /*width: theme.themeDefaultWidth,*/ /*margin: "0 !important", padding: "0 !important",*/ background: "linear-gradient(0deg, #A3062E 0%, #D40037 100%)" },
	ToolBarMobileBottom: { display: "flex", /*width: theme.themeDefaultWidth,*/ margin: "0 auto", background: "#1A1A1A" },
	AppBar: { backgroundColor: "#2A2A2A"/*, left: "0px !important", width: "100vw !important"*/ }, //theme.palette.background.default "#2A2A2A"
	NavBarLogo: {
		justifyContent: "flex-start", padding: "10px 40px 10px 40px", width: 190, height: 60, cursor: "pointer",
		"&:hover": {
			background: "rgba(255, 255, 255, 0.10)"
		}
	},
	NavBarMedium: {
		justifyContent: "flex-start", position: "relative", top: "5px", padding: "10px 40px 0px 40px", width: 190, height: 40, cursor: "pointer",
		"&:hover": {
			background: "rgba(255, 255, 255, 0.10)"
		}
	},
	NavBarLogoMobile: {
		justifyContent: "flex-start", padding: "18px 0px 4px 0px", width: 146, height: 48, cursor: "pointer",
		"&:hover": {
			background: "rgba(255, 255, 255, 0.10)"
		}
	},
	NavBarWrapper: { justifyContent: "flex-end", display: "flex", flex: 1 },
	//NavBarItem: { margin: "8px 0 0 16px", textTransform: "none", fontSize: "0.75rem", opacity: 0.6, letterSpacing: 0.4, fontWeight: "normal" },
	NavBarItem: { margin: "0 0 0 16px", textTransform: "none", fontSize: "1rem", color: "#FFFFFF", opacity: 1, letterSpacing: 0.4, fontWeight: "normal" },
	NavBarItemSettings: { margin: 0 },
	NavBarItemLink: { "&:hover": { textDecoration: "none" } },
	//NavBarSearchIcon: { paddingRight: 0, opacity: 0.54, marginTop: 0, paddingLeft: 3, marginRight: 1, "&:hover": { backgroundColor: "transparent" } },
	// for scaling on zoom
	Icons: { display: "inline-block", overflow: "hidden", width: 14 },
	// Navbar responsive logo and topmenu
	NavBarWrapperResponsive: { display: "flex", width: "100%" },
	TopMenuTabsSearch: { flexGrow: 1, minHeight: 40 }, //search
	TabItemSearch: { minWidth: "60px !important", width: "60px !important"/*, maxHeight: "40px !important"*/ /*minHeight: 74.8*/ },
	TopMenuWrapperSearch: {
		right: "80px",
		position: "absolute",
		/*
		"&:hover": {
			background: "rgba(255, 255, 255, 0.2)",
		}
		*/
	},
	TopMenuWrapperSearchMobile: {
		width: "40px",
		right: "80px",
		position: "absolute",
		/*
		"&:hover": {
			background: "rgba(255, 255, 255, 0.2)",
		}
		*/
	},
	// MTVW-947: performance, disable transition (reflows)
	root: {
		"& .MuiTabs-indicator": {
			transition: "none"
		}
	}
})

let pressTimer = null
export const NavBar = memo(CreateComponent(styles, false, true, ({ classes }) => {
	const navigateRouteAdd = useNavigateRouteAdd()
	const navigate = useNavigate()

	const downEvent = (e) => {
		e.preventDefault()
		e.stopPropagation()
		pressTimer = setTimeout(() => {
			//console.debug("elapsed %s", window.location.href)
			pressTimer = null
			startVConsole(true)
			navigateRouteAdd(ROUTE_NAMES.Internals)
		}, 3000)
	}
	const upEvent = (e) => {
		e.preventDefault()
		e.stopPropagation()
		if (pressTimer !== null) navigateRouteAdd(ROUTE_NAMES.Discover)
		clearTimeout(pressTimer)
	}

	// MTVW-918
	const isMobile = useMediaQuery('(max-width: 540px)')
	// MTVW-1061: zing radio 1024 -> 1220, 1025 -> 1221
	// MTVW-1142: revert to 1024px and 1025px
	const isMedium = useMediaQuery('(min-width: 541px) and (max-width: 1024px)')
	const isLarge = useMediaQuery('(min-width: 1025px)')
	const iconSize = isMobile ? 20 : isMedium ? 22.5 : 30

	const [page, setPage] = useState(null)

	/* would go back if overlay is closed, could be fixed with an additional check for rootSearch present,
		simpler solution is to use handleClose insted
	function handleSearchState(event, newValue) {
		console.debug("searchRef change", newValue, page?.location)
		// MTVW-941: DO NOT go back if OverlayEventDetails is visible
		if (page?.location === "search" && newValue === "Search" && !rootStore.page.OverlayEventDetails.isVisible) {
			if (window.performance.now() - page?.since > 500) {
				console.debug("searchRef leaving")
				navigate(-1)
			}
		}
	}
	*/

	function handleClose(event) {
		event.preventDefault()
		//console.debug("clicked CloseIcon")
		navigate(-1)
	}

	useEffect(() => {
		const href = window.location.href
		const ix = href.lastIndexOf('/')
		const result = href.substring(ix + 1)
		setPage({ location: result, since: window.performance.now() })
		console.debug("searchRef location change", result, window.location.href)
		return (() => {
		})
	}, [window.location.href])

	return (
		// MTVW-754 trial
		<div /*style={{
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
		}}*/>
			{(!rootStore.page.Player.settings.isFullScreen) && <AppBar /*position="unset"*/ enableColorOnDark className={classes.AppBar} /*style={{
				position: "relative", margin: "0 auto", width: "80vw"
			}}*/>
				<div id="navbarContainer" className={classes.root}>
					{/* top toolbar */}
					<Toolbar className={isMobile ? classes.ToolBar + " NavBarContainer" : classes.ToolBar + " NavBarContainer"}>
						{/* CHECK_MERGE */}
						<div className={classes.NavBarWrapperResponsive + " NavBarWrapperResponsive"}
							style={{ height: isMedium ? 90 : 60 }}>
							{/*<Link underline="hover" to="/">*/}
							<img src={logoWhite} className={isMobile ? classes.NavBarLogoMobile : isMedium ? classes.NavBarMedium : classes.NavBarLogo} alt="Quickline"
								onMouseDown={e => { downEvent(e) }}
								onMouseUp={e => { upEvent(e) }}
								onTouchStart={e => { downEvent(e) }}
								onTouchEnd={e => { upEvent(e) }} />
							{/*</Link>*/}
							{!isMobile &&
								<TopMenu />
							}
						</div>
						<div className={isMobile ? classes.TopMenuWrapperSearchMobile + " TopMenuWrapperSearchResponsive" : classes.TopMenuWrapperSearch + " TopMenuWrapperSearchResponsive"}>
							{/* MTVW-1078: reduce hover height of search tab */}
							<RouteTabs
								sx={{ maxHeight: 60 }}
								centered className={classes.TopMenuTabsSearch + " TopMenuTabsSearchResponsive"}
								routeCustomName="search_menu"
								// see comment in handleSearchState above
								//onChange={handleSearchState}
								// MTVW-918: change the bar below the selected tab
								slotProps={{ indicator: { style: { backgroundColor: "#FFF" }, className: classes.indicator } }}
							>
								<RouteTab className={classes.TabItemSearch + " TabItemSearchResponsive"}
									icon={page?.location !== "search" ?
										<img src={searchIcon} alt="search"
											style={{ /*transform: "scale(1.3)",*/ height: iconSize, width: iconSize/*, paddingBottom: 4*/ }}></img> :
										<CloseIcon sx={{ color: "#FFF", width: iconSize * 1.4, height: iconSize * 1.4, marginTop: isMedium ? 4 : 0, paddingBottom: isLarge ? 3 : 0}}
											onClick={handleClose} />}
									value="Search"
									data-test="search"
									sx={{ '&.Mui-selected': { backgroundColor: "rgba(255, 255, 255, 0.10)" } }} />
							</RouteTabs>
							{/* NEVER-USED .. {rootStore.page.Recordings.isVisible && <RecordingsMenuIcons page={rootStore.page.Recordings} />} */}
						</div>

						<div className={classes.NavBarWrapper + " NavBarWrapperMenuResponsive"}>
							<ProfileMenu classNames={classes} />
						</div>
					</Toolbar>
					{/* MTVW-918 */}
					{isMobile &&
						// bottom toolbar
						<Toolbar className={classes.ToolBarMobileBottom + " NavBarContainer"} style={{ /*display: "block",*/  width: "100%", height: "64px", position: "fixed", bottom: 0 }} >
							<TopMenu />
						</Toolbar>
					}
				</div>
			</AppBar>}
				{/* Add empty toolbar, THUS pagewrapper BEGINS RIGHT AFTER THE AppBar and we don't need to apply paddings / margins
			    for all the pages anymore (check also 'position: fixed in' .tvGuideHead)
				 See https://mui.com/material-ui/react-app-bar/#fixed-placement*/}
				{(!rootStore.page.Player.settings.isFullScreen) &&
				<Toolbar />
			}
		</div>
	)
}))
